// MembershipRoles.js

import React from 'react';
import { Chip, Typography } from '@mui/material';

import './MembershipRoles.css';

const MembershipRoles = ({ memberRoles, organizationRoles, onUpdateRoles }) => {
    const handleRoleToggle = (roleId, enabled) => {
        const updatedRoles = enabled
            ? [...(memberRoles ?? []), { roleId, roleName: getRoleNameById(roleId) }]
            : (memberRoles ?? []).filter((role) => role.roleId !== roleId);

        onUpdateRoles(updatedRoles);
    };

    const getRoleNameById = (roleId) => {
        const role = organizationRoles.find((role) => role.roleId === roleId);
        return role ? role.roleName : '';
    };

    return (
        <>
            <Typography variant="h9" gutterBottom className="membershipRoles-title">Roles: </Typography>
            <div className="membershipRoles">
                {Array.isArray(organizationRoles) && organizationRoles.map((role) => (
                    <Chip
                        key={role.roleId}
                        label={role.roleName}
                        clickable
                        size="small"
                        color={(memberRoles ?? []).some((userRole) => userRole.roleId === role.roleId) ? 'primary' : 'default'}
                        onClick={() => handleRoleToggle(role.roleId, !((memberRoles ?? []).some((userRole) => userRole.roleId === role.roleId)))}
                    />
                ))}
            </div>
        </>
    );
};

export default MembershipRoles;